import * as React from 'react';
import {ButtonToolbar, Container, Modal} from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faShareAlt} from '@fortawesome/free-solid-svg-icons';
import {Bar, BarChart, Cell, Tooltip, XAxis} from 'recharts';
import PulsoidClient from '../../PulsoidClient';
import {useEffect, useState} from 'react';
import Form from 'react-bootstrap/Form';
import twitter from '../analytics/twitter.png';
import facebook from '../analytics/facebook.png';
import {Action, ActionHref, ActionLink, Copy} from '../../system/buttons';
import ResponsiveContainer from 'recharts/lib/component/ResponsiveContainer';

export const YearlyReportContainer = () => {
  let [report, setReport] = useState(undefined);
  let [shareModal, setShareModal] = useState(false);
  useEffect(() => {
    new PulsoidClient().getYearlyReport().then((report) => setReport(report));
  }, []);

  if (report) {
    return (
      <div style={{width: '100%', backgroundColor: 'rgb(34, 34, 34)'}}>
        <Container
          style={{
            backgroundColor: 'rgb(34, 34, 34)',
            fontFamily: 'lato-light, lato, sans-serif',
            fontWeight: 1,
          }}
        >
          <ShareModal
            show={shareModal}
            close={() => setShareModal(false)}
            reportId={report.id}
          />
          <Row>
            {
              <Col className={'text-right'}>
                <Action onClick={() => setShareModal(true)}>
                  <FontAwesomeIcon icon={faShareAlt} />
                  &nbsp;Share
                </Action>
              </Col>
            }
          </Row>
        </Container>
        <YearlyReport report={report} />
      </div>
    );
  } else {
    return <div>LOADING...</div>;
  }
};

export class YearlyReport extends React.Component {
  render() {
    let {
      count,
      sessions,
      avg,
      p95,
      max,
      rating,
      uniqueWidgets,
      histogram,
      songId,
      achievements,
      channel,
    } = this.props.report;

    let channelTitle = '';
    if (channel) {
      channelTitle = channel + "'s";
    }

    histogram.sort((left, right) => left.value - right.value);
    if (histogram[0].value === 0) {
      histogram.shift();
    }

    let hoursBroadcasted = Math.floor(count / (60 * 60));
    let itTakesTwo = (hoursBroadcasted / 10.66).toFixed(1);

    let redRange = 0;
    let yellowRange = 0;

    if (histogram.length > 0) {
      redRange = Math.floor(histogram[histogram.length - 1].value * 0.85);
      yellowRange = Math.floor(histogram[histogram.length - 1].value * 0.65);
    }

    let calories = Math.floor(
      ((-55 + 0.63 * avg + 0.19 * 72 + 0.2 * 28) * (count / 60)) / 4.184
    );
    let maraphons = Math.floor(calories / 2600);
    let carrots = Math.floor(calories / 25);
    let bigMacs = Math.floor(calories / 550);

    return (
      <Container
        style={{
          textAlign: 'center',
          backgroundColor: 'rgb(34, 34, 34)',
          fontFamily: 'lato-light, lato, sans-serif',
          fontWeight: 1,
        }}
      >
        <Row
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
          className={'p-3'}
        >
          <Col md={'auto'}>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'center',
                color: 'rgb(17, 162, 177)',
              }}
            >
              <span style={{fontSize: '4em'}}>
                {channelTitle} #2021OfMyHeart
              </span>
            </Row>
            <Row style={{justifyContent: 'flex-end'}}>
              powered by &nbsp;
              <a
                href={'https://pulsoid.net'}
                style={{color: 'rgb(17, 162, 177)'}}
              >
                {' '}
                PULSOID
              </a>
            </Row>
          </Col>
        </Row>
        <Row>
          <Coll>
            <Roww>
              <Square
                comment={'Hours broadcasted'}
                icon={
                  <svg viewBox="39.999 39.5 120 121" height="70px" id="clock">
                    <g>
                      <path
                        d="M100.023 39.5c-.392 0-.782.004-1.174.013-16.024.308-30.969 6.891-42.084 18.536-11.11 11.643-17.062 26.954-16.755 43.114.62 32.717 27.519 59.337 59.965 59.337.39 0 .782-.005 1.171-.011 16.024-.308 30.969-6.893 42.084-18.536 11.112-11.647 17.063-26.956 16.757-43.114-.62-32.718-27.52-59.339-59.964-59.339zm37.188 96.609c-9.564 10.024-22.43 15.691-36.222 15.957-.337.007-.675.011-1.012.011-27.927 0-51.077-22.912-51.612-51.077-.263-13.907 4.859-27.088 14.423-37.11 9.566-10.022 22.428-15.689 36.222-15.957.339-.007.675-.009 1.014-.009 27.924 0 51.077 22.912 51.61 51.077.265 13.905-4.857 27.084-14.423 37.108z"
                        fill="#FFFFFF"
                        data-color="1"
                      ></path>
                      <path
                        fill="#FFFFFF"
                        d="M104.178 62.848H95.82v41.363h31.694v-8.422h-23.336V62.848z"
                        data-color="1"
                      ></path>
                    </g>
                  </svg>
                }
                value={hoursBroadcasted}
              />
            </Roww>
            <div className={'pt-5'}>
              <svg viewBox="38.5 38.5 123 123" height="40px">
                <g>
                  <path
                    fill="#FFFFFF"
                    d="M158.572 82.429v5.857H41.429v-5.857h117.143z"
                    data-color="1"
                  ></path>
                  <path
                    fill="#FFFFFF"
                    d="M123.428 53.143V59H76.571v-5.857h46.857z"
                    data-color="1"
                  ></path>
                  <path
                    d="M152.714 161.5H47.286c-4.845 0-8.786-3.941-8.786-8.786V61.929c0-4.845 3.941-8.786 8.786-8.786H59V59H47.286a2.931 2.931 0 0 0-2.929 2.929v90.786a2.931 2.931 0 0 0 2.929 2.929h105.429a2.931 2.931 0 0 0 2.929-2.929V61.929A2.931 2.931 0 0 0 152.715 59H141v-5.857h11.714c4.845 0 8.786 3.941 8.786 8.786v90.786c0 4.844-3.941 8.785-8.786 8.785z"
                    fill="#FFFFFF"
                    data-color="1"
                  ></path>
                  <path
                    d="M143.929 67.786H120.5V44.357a5.864 5.864 0 0 1 5.857-5.857h11.714a5.864 5.864 0 0 1 5.857 5.857v23.429zm-17.572-5.857h11.714V44.357h-11.714v17.572z"
                    fill="#FFFFFF"
                    data-color="1"
                  ></path>
                  <path
                    d="M79.5 67.786H56.071V44.357a5.864 5.864 0 0 1 5.857-5.857h11.714a5.864 5.864 0 0 1 5.857 5.857v23.429zm-17.571-5.857h11.714V44.357H61.929v17.572z"
                    fill="#FFFFFF"
                    data-color="1"
                  ></path>
                  <path
                    fill="#FFFFFF"
                    d="M94.143 102.929v5.857H82.429v-5.857h11.714z"
                    data-color="1"
                  ></path>
                  <path
                    fill="#FFFFFF"
                    d="M117.571 102.929v5.857h-11.714v-5.857h11.714z"
                    data-color="1"
                  ></path>
                  <path
                    fill="#FFFFFF"
                    d="M141 102.929v5.857h-11.714v-5.857H141z"
                    data-color="1"
                  ></path>
                  <path
                    fill="#FFFFFF"
                    d="M70.714 117.571v5.857H59v-5.857h11.714z"
                    data-color="1"
                  ></path>
                  <path
                    fill="#FFFFFF"
                    d="M94.143 117.571v5.857H82.429v-5.857h11.714z"
                    data-color="1"
                  ></path>
                  <path
                    fill="#FFFFFF"
                    d="M117.571 117.571v5.857h-11.714v-5.857h11.714z"
                    data-color="1"
                  ></path>
                  <path
                    fill="#FFFFFF"
                    d="M141 117.571v5.857h-11.714v-5.857H141z"
                    data-color="1"
                  ></path>
                  <path
                    fill="#FFFFFF"
                    d="M70.714 132.214v5.857H59v-5.857h11.714z"
                    data-color="1"
                  ></path>
                  <path
                    fill="#FFFFFF"
                    d="M94.143 132.214v5.857H82.429v-5.857h11.714z"
                    data-color="1"
                  ></path>
                  <path
                    fill="#FFFFFF"
                    d="M117.571 132.214v5.857h-11.714v-5.857h11.714z"
                    data-color="1"
                  ></path>
                </g>
              </svg>
            </div>

            <div className={'pt-5 pb-5'}>
              <Roww>
                <span style={{fontSize: '2em'}}>{sessions} times</span>
              </Roww>
              <Roww>
                <span style={{fontSize: '1.2em'}}>
                  you used heart rate <br />
                  widget on your stream
                </span>
              </Roww>
            </div>
            <div className={'pt-5 pb-5'}>
              <Roww>
                <span style={{fontSize: '2em'}}>{itTakesTwo} times</span>
              </Roww>
              <Roww>
                <span className={'pb-4'} style={{fontSize: '1.2em'}}>
                  you could’ve completed It Takes Two
                </span>
              </Roww>
            </div>
          </Coll>
          <Coll>
            <Roww>
              <Square
                comment={'Average heart rate'}
                icon={
                  <svg viewBox="24.5 63.85 151 72.25" width="70px">
                    <g>
                      <path
                        d="M175.3 100.9c.2-.4.2-.6.2-1s0-.6-.2-1-.4-.6-.6-.8l-33.4-33.5c-1-1-2.5-1-3.5 0s-1 2.5 0 3.5l29.3 29.2h-134l29.3-29.2c1-1 1-2.5 0-3.5s-2.5-1-3.5 0L25.3 98.2c-.2.2-.4.6-.6.8-.2.2-.2.6-.2 1s0 .6.2 1 .4.6.6.8l33.6 33.5c.4.4 1.2.8 1.7.8.6 0 1.2-.2 1.7-.8 1-1 1-2.5 0-3.5L33 102.6h134.1l-29.3 29.2c-1 1-1 2.5 0 3.5.4.4 1.2.8 1.7.8.6 0 1.2-.2 1.7-.8l33.6-33.5c.3-.3.5-.7.5-.9z"
                        fill="#FFFFFF"
                        data-color="1"
                      ></path>
                    </g>
                  </svg>
                }
                value={avg}
              />
            </Roww>
            <div className={'pt-5'}>
              <svg viewBox="22 33 156 134" height="40px">
                <g>
                  <path
                    fill="#FFFFFF"
                    d="M23.456 167c-.803 0-1.456-.65-1.456-1.451V34.45c0-.8.653-1.45 1.456-1.45h153.088c.803 0 1.456.65 1.456 1.45v131.099c0 .8-.653 1.451-1.456 1.451H23.456zm151.632-2.901V35.901H24.912v128.198h150.176zm-38.751-16.832c-1.012 0-1.593-.579-1.593-1.587V87.486c0-1.008.581-1.587 1.593-1.587h14.535c1.012 0 1.592.579 1.592 1.587v58.194c0 1.008-.58 1.587-1.592 1.587h-14.535zm12.942-3.174v-55.02H137.93v55.02h11.349zm-42.011 3.174c-1.012 0-1.593-.579-1.593-1.587v-37.704c0-1.008.581-1.587 1.593-1.587h14.534c.766 0 1.592.606 1.592 1.587v37.704c0 1.008-.58 1.587-1.592 1.587h-14.534zm12.942-3.174v-34.53h-11.35v34.53h11.35zm-42.285 3.174c-1.012 0-1.592-.579-1.592-1.587V89.399c0-1.008.58-1.587 1.592-1.587H92.46c1.012 0 1.593.579 1.593 1.587v56.282c0 1.008-.581 1.587-1.593 1.587H77.925zm12.942-3.174V90.985H79.518v53.108h11.349zm-42.011 2.901c-1.012 0-1.592-.579-1.592-1.587v-35.79c0-1.008.58-1.587 1.592-1.587h14.535c.744 0 1.592.845 1.592 1.587v35.79c0 1.009-.58 1.587-1.592 1.587H48.856zm12.942-2.901v-32.89H50.449v32.89h11.349zm53.149-48.737c-4.961 0-8.997-4.021-8.997-8.963 0-1.214.249-2.449.74-3.672l.311-.774-15.837-13.099-.713.473c-1.365.906-3.28 1.447-5.122 1.447-1.702 0-3.377-.563-5.121-1.72l-.694-.461L63.863 80.88l.418.835c.452.901.701 2.077.701 3.313 0 5.11-3.868 8.963-8.996 8.963-5.129 0-8.997-3.853-8.997-8.963 0-4.943 4.036-8.964 8.997-8.964 1.704 0 3.379.563 5.121 1.721l.703.468 15.569-12.528-.3-.779c-1.318-3.413-.559-7.225 1.933-9.707 1.615-1.61 3.918-2.533 6.317-2.533s4.702.923 6.317 2.533c2.53 2.52 3.224 6.597 1.689 9.912l-.367.791 15.589 13.141.72-.479c1.447-.96 3.169-1.447 5.121-1.447 1.703 0 3.378.563 5.121 1.721l.694.46 15.652-12.293-.418-.835c-.453-.9-.702-2.077-.702-3.312 0-4.943 4.036-8.964 8.997-8.964 5.085 0 9.545 4.316 9.545 9.237 0 4.943-4.036 8.964-8.997 8.964-1.701 0-3.376-.563-5.121-1.721l-.694-.461-15.651 12.293.418.835c.452.901.701 2.077.701 3.313 0 5.109-3.867 8.962-8.996 8.962zm-.141-14.629c-3.368 0-5.812 2.435-5.812 5.79 0 3.247 2.553 5.79 5.812 5.79s5.812-2.543 5.812-5.79c0-3.246-2.553-5.79-5.812-5.79zM56.109 79.39c-3.367 0-5.812 2.435-5.812 5.791 0 3.247 2.553 5.79 5.812 5.79s5.812-2.543 5.812-5.79-2.553-5.791-5.812-5.791zm87.877-22.251c-3.367 0-5.812 2.435-5.812 5.79 0 3.247 2.553 5.79 5.812 5.79 3.259 0 5.812-2.543 5.812-5.79s-2.553-5.79-5.812-5.79zm-58.473-1.276c-1.567 0-2.986.589-4.104 1.702-2.053 2.379-2.067 5.78-.06 8.112a5.19 5.19 0 0 0 3.941 1.802c1.617 0 3.205-.744 4.357-2.041l.274-.273c1.838-2.195 1.702-5.603-.304-7.6-1.118-1.113-2.537-1.702-4.104-1.702z"
                    data-color="1"
                  ></path>
                </g>
              </svg>
            </div>

            <div className={'pt-5 pb-5'}>
              <Roww>
                <span style={{fontSize: '2em'}}>{p95} bpm</span>
              </Roww>
              <Roww>
                <span style={{fontSize: '1.2em'}}>is your hype heart rate</span>
              </Roww>
            </div>
            <div className={'pt-5 pb-5'}>
              <Roww>
                <span style={{fontSize: '2em'}}>{count} times</span>
              </Roww>
              <Roww>
                <span className={'pb-4'} style={{fontSize: '1.2em'}}>
                  your heart have beaten <br />
                  with Pulsoid
                </span>
              </Roww>
            </div>
          </Coll>
          <Coll>
            <Roww>
              <Square
                comment={'Maximum heart rate'}
                icon={
                  <svg viewBox="39.5 45 121 110" height="70px">
                    <g>
                      <path
                        d="M100 155l-50.845-50.92C43.111 97.644 39.5 88.53 39.5 79.703 39.5 60.566 55.046 45 74.153 45 84.179 45 93.484 49.258 100 56.621 106.52 49.258 115.823 45 125.847 45c19.107 0 34.653 15.566 34.653 34.703 0 8.828-3.611 17.943-9.655 24.377l-.087.089L100 155zM55.249 98.255L100 143.068l44.753-44.813c4.587-4.906 7.322-11.836 7.322-18.551 0-14.484-11.763-26.266-26.228-26.266-9.108 0-17.433 4.651-22.27 12.446l-3.579 5.769-3.575-5.769c-4.834-7.795-13.159-12.446-22.27-12.446-14.463 0-26.228 11.782-26.228 26.266 0 6.712 2.738 13.642 7.324 18.551z"
                        fill="#FFFFFF"
                        data-color="1"
                      ></path>
                    </g>
                  </svg>
                }
                value={max}
              />
            </Roww>
            <div className={'pt-5'}>
              <svg viewBox="49 43 102 114" height="40px">
                <g>
                  <path
                    d="M119.251 80.852L151 43H49v114h8.415v-38.299H151l-31.749-37.849zM57.415 51.469h75.468l-24.645 29.382 24.643 29.38H57.415V51.469z"
                    fill="#FFFFFF"
                    data-color="1"
                  ></path>
                </g>
              </svg>
            </div>

            <div className={'pt-5 pb-5'}>
              <Roww>
                <span style={{fontSize: '2em'}}>{rating}%</span>
              </Roww>
              <Roww>
                <span style={{fontSize: '1.2em'}}>
                  you are one of Pulsoid top {rating}% <br /> active users
                </span>
              </Roww>
            </div>
            <div className={'pt-5 pb-5'}>
              <Roww>
                <span style={{fontSize: '2em'}}>{uniqueWidgets}</span>
              </Roww>
              <Roww>
                <span className={'pb-4'} style={{fontSize: '1.2em'}}>
                  unique widgets you've used
                </span>
              </Roww>
            </div>
          </Coll>
        </Row>
        <Row
          style={{
            display: 'flex',
            justifyContent: 'center',
            color: 'rgb(17, 162, 177)',
          }}
        >
          <span style={{fontSize: '8vh'}}>Heart Rate Histogram</span>
        </Row>
        <Row>
          <ResponsiveContainer height={400}>
            <BarChart
              width={1100}
              height={400}
              data={histogram}
              // stackOffset={"sign"}
              barCategoryGap={0}
            >
              <XAxis
                dataKey="value"
                stroke="#8884d8"
                // tickFormatter={(unixTime) => moment(unixTime).format('HH:mm Do')}
              />
              {/*<YAxis interval={"preserveStart"} domain={['0', 'dataMax + 10']}/>*/}
              <Tooltip
                labelFormatter={() => {
                  return '';
                }}
                formatter={(value, name, props) => {
                  return [
                    <div>
                      Heart Rate: {props.payload.value} <br /> Times:{' '}
                      {props.payload.count}
                    </div>,
                  ];
                }}
              />
              {/*<CartesianGrid stroke="#ccc" strokeDasharray="5 5"/>*/}

              {/*<YAxis padding={{top: 10}}/>*/}

              <Bar dataKey="count">
                {histogram.map((entry, index) => {
                  if (entry.value > redRange) {
                    return (
                      <Cell
                        key={`cell-${index}`}
                        stroke={'red'}
                        fill={'black'}
                        strokeWidth={'2'}
                      />
                    );
                  } else if (
                    entry.value > yellowRange &&
                    entry.value <= redRange
                  ) {
                    return (
                      <Cell
                        key={`cell-${index}`}
                        stroke={'yellow'}
                        fill={'black'}
                        strokeWidth={'2'}
                      />
                    );
                  } else {
                    return (
                      <Cell
                        key={`cell-${index}`}
                        stroke={'rgb(17, 162, 177)'}
                        strokeWidth={'2'}
                      />
                    );
                  }
                })}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Row>
        <Row
          style={{
            display: 'flex',
            justifyContent: 'center',
            color: 'rgb(17, 162, 177)',
          }}
        >
          <span style={{fontSize: '8vh'}}>Calories</span>
        </Row>
        <Row>
          <Col>
            <Roww>
              <Col md={'auto'}>
                <svg height="80px" viewBox="53.5 23 93 154.001">
                  <g>
                    <path
                      fill="#FFFFFF"
                      d="M94.041 176.602s-30.785-5.289-38.199-33.211c-7.264-27.357 3.696-42.898 14.737-55.352C81.62 75.584 103.77 58.819 94.041 23c0 0 44.34 24.564 26.567 89.282 0 0 13.096-10.317 11.225-29.076 0 0 15.189 24.172 14.653 47.731-.621 27.305-20.266 40.436-36.168 46.064 0 0 11.225-15.007-9.821-31.78-14.175-11.297-2.34-38.566-2.34-38.566s-41.16 25.324-4.116 69.947z"
                      data-color="1"
                    ></path>
                  </g>
                </svg>
              </Col>
              <Col md={'auto'}>
                <span style={{fontSize: '6vh'}}>{calories}</span>
              </Col>
            </Roww>
            <Row className={'p-4'} />
            <Roww>
              <span style={{fontSize: '1.4rem'}}>
                {' '}
                Calories you’ve burned
                <br /> using Pulsoid this year
              </span>
            </Roww>
          </Col>
          <Col>
            <Roww className={'pt-4 pb-4'}>
              <span style={{fontSize: '1.4rem'}}>This number of calories:</span>
            </Roww>
            <Row className={'pt-4 pb-4'}>
              <Col md={1} />
              <Col md={'auto'}>
                <svg
                  height="30px"
                  viewBox="53.091 55.4 93.821 89.2"
                  width={'30px'}
                >
                  <g>
                    <path
                      fill="#FFFFFF"
                      d="M144.385 75.257c-1.172-.706-2.822-1.289-4.419-1.852-1.004-.355-2.036-.719-2.888-1.094-2.05-5.047-6.657-8.281-10.491-10.55-.992-.588-1.908-1.128-2.782-1.643a460.696 460.696 0 0 1-7.516-4.497 1.493 1.493 0 0 0-1.834.214c-4.016 3.992-4.369 5.957-5.074 9.871-.174.965-.371 2.059-.653 3.363-.642 2.959-2.408 3.084-6.015 3.078-1.805-.004-3.838-.001-5.675.695-2.502-4.652-6.277-7.644-10.175-8.027-2.401-.237-4.55.609-5.899 2.318a1.494 1.494 0 0 0-.209 1.493c.68 1.654 1.116 2.726 1.553 3.799.374.918.757 1.86 1.283 3.142-.778 1.35-1.256 3.431-1.511 6.598-.35.03-.7.087-1.051.208a1.49 1.49 0 1 0 .882 2.845c-.033.973-.054 2.017-.062 3.15-.002.314-.017.639-.043.973a3.903 3.903 0 0 0-1.114.212 1.494 1.494 0 0 0-.888 1.917 1.488 1.488 0 0 0 1.515.968 40.963 40.963 0 0 1-1.032 3.736c-.287.04-.574.113-.858.235a1.493 1.493 0 0 0-.786 1.96c.132.308.357.544.626.7-.37.98-.77 1.973-1.189 2.97a3.16 3.16 0 0 0-1.143.223 1.493 1.493 0 0 0-.83 1.942c.137.342.39.599.692.759-3.764 8.277-8.405 16.083-9.327 17.613-1.271.865-6.985 4.675-10.63 5.746-2.282.671-2.981 2.877-3.357 4.062-.047.148-.091.288-.135.414-.65 1.862-.038 4.697 1.394 6.453 3.889 4.769 10.416 5.349 15.946 5.349.933 0 1.839-.017 2.698-.032l1.383-.023c4.281-.065 8.707-.133 12.825-2.075 9.058-4.271 15.74-13.155 21.808-21.889 4.5-6.477 9.489-10.725 14.771-15.223a255.56 255.56 0 0 0 5.041-4.371l.184-.165c6.414-5.757 12.473-11.195 16.792-18.834 1.422-2.518.696-5.223-1.807-6.731zm-57.815-7.47c2.147.211 5.166 1.878 7.502 5.866-1.571.202-2.967.031-4.25-.133-1.352-.173-2.648-.326-3.824.043l-.924-2.265c-.351-.862-.701-1.723-1.177-2.884.696-.51 1.619-.731 2.673-.627zm-6.864 38c.302.21.647.465 1.063.798.173.138.332.266.474.374a1.493 1.493 0 0 0 1.815-2.373c-.126-.096-.267-.21-.421-.333-.474-.38-1.064-.85-1.721-1.26a86.082 86.082 0 0 0 1.298-3.307c.515.3 1.015.645 1.301.845.216.151.417.29.595.408a1.49 1.49 0 0 0 2.068-.429c.452-.69.26-1.615-.429-2.068-.158-.104-.334-.227-.525-.36-.576-.401-1.268-.882-2.022-1.265a44.307 44.307 0 0 0 1.022-3.729c.363.203.708.414.995.59.209.129.406.25.59.359a1.49 1.49 0 0 0 2.045-.526 1.495 1.495 0 0 0-.526-2.046c-.169-.1-.351-.212-.542-.33-.586-.361-1.286-.792-2.05-1.144.056-.552.096-1.092.1-1.602.004-.578.011-1.431.037-2.409.339.186.663.378.949.548.177.105.348.207.51.3a1.494 1.494 0 0 0 1.495-2.586c-.153-.088-.313-.184-.48-.282-.684-.406-1.473-.867-2.318-1.227.2-2.684.615-5.354 1.495-6.123.246-.215.603-.295 1.102-.295.471 0 1.068.071 1.818.167 1.123.143 2.472.307 4.005.222-.03 2.003-.018 4.144-.006 6.089.005.898.01 1.768.011 2.585.004 3.08-.557 4.919-2.223 7.287a6.144 6.144 0 0 1-.453.537 7.659 7.659 0 0 0-.468.551c-1.634 2.212-1.514 5.012-1.227 7.205v.001c.406 3.1-.194 5.839-1.734 7.921-.473.64-1.086 1.277-1.678 1.893l-.418.437c-.751.794-1.105 1.38-1.572 2.318-.202.405-.417.893-.644 1.41-.511 1.162-1.091 2.478-1.662 3.167-.427.515-.674.615-.8.607-.116-.007-.375-.12-.804-.792-.155-.242-.388-1.031-.613-1.793-.551-1.867-1.155-3.924-2.137-4.699a144.054 144.054 0 0 0 2.685-5.641zm-23.538 27.997c.053-.152.107-.319.163-.497.337-1.063.65-1.893 1.351-2.099 4.568-1.343 11.462-6.135 11.753-6.338.168-.117.31-.268.418-.443.278-.453 3.418-5.598 6.752-12.156.688.74 1.346 2.956 1.693 4.13.315 1.068.504 1.689.717 2.022.344.539.825 1.162 1.504 1.204l.072.002c.619 0 1.111-.495 1.473-.932.651-.785 1.257-2.162 1.792-3.378.223-.507.434-.986.626-1.372.436-.875.744-1.386 1.421-2.101.133-.141.272-.285.413-.432.584-.607 1.245-1.295 1.753-1.981 1.678-2.268 2.337-5.226 1.904-8.555l-.004-.063a.448.448 0 0 0-.017-.097c-.251-2.003-.332-4.504 1.077-6.412.109-.147.256-.31.412-.483.184-.203.374-.414.521-.622 1.766-2.51 2.391-4.553 2.387-7.804-.001-.818-.006-1.69-.011-2.589a294.3 294.3 0 0 1 .008-6.157 13.68 13.68 0 0 0 3.613-.95c1.341-.554 3.073-.551 4.745-.547 3.466.01 7.758.017 8.94-5.432.294-1.355.496-2.477.674-3.467.608-3.378.849-4.713 3.424-7.446 2.299 1.4 4.287 2.572 6.543 3.902.872.514 1.786 1.053 2.777 1.64 3.701 2.191 7.682 5.013 9.329 9.337-.33.177-.832.487-1.649.991-10.116 6.248-19.74 15.578-26.404 25.6l-.127.19c-1.427 2.144-4.767 7.166-6.393 10.059-1.494 2.658-3.706 6.426-5.436 9.029-1.498 2.254-3.363 5.06-5.388 7.313-2.086 2.321-4.227 4.174-6.364 5.507-2.504 1.562-4.805 2.905-7.618 3.506-4.021.859-7.912 1.04-12.616.583-1.05-.102-2.02-.259-3.047-.426l-.795-.128-.16-.025c-.847-.132-1.643-.279-2.278-.775-.072-.515-.06-.987.052-1.308zm87.422-53.267c-4.078 7.213-9.96 12.492-16.187 18.081l-.184.165c-1.682 1.51-3.359 2.938-4.982 4.32-5.434 4.627-10.566 8.998-15.288 15.793-5.837 8.401-12.238 16.934-20.629 20.891-3.534 1.667-7.633 1.729-11.597 1.79l-1.392.023c-5.636.103-12.647.231-16.275-4.218a4.14 4.14 0 0 1-.595-1.037c.579.229 1.193.33 1.797.424l.159.025c.268.042.531.085.792.128 1.042.169 2.025.329 3.104.434 1.698.165 3.292.248 4.826.248 2.803 0 5.404-.278 8.063-.846 2.954-.632 5.328-2.014 7.905-3.622 2.207-1.377 4.413-3.284 6.555-5.668 2.069-2.302 3.954-5.138 5.468-7.416 1.744-2.624 3.969-6.414 5.471-9.086 1.609-2.864 4.937-7.866 6.358-10.002l.127-.19c6.595-9.918 16.119-19.152 26.128-25.334.319-.197 1.158-.715 1.562-.952.02-.002.048-.014.07-.018.114.115.238.222.386.295 1.09.541 2.436 1.016 3.738 1.475 1.455.514 2.96 1.045 3.871 1.594 1.404.846 1.182 1.937.749 2.703z"
                      data-color="1"
                    ></path>
                  </g>
                </svg>
              </Col>
              <Col md={'auto'}>
                <span style={{fontSize: '1.3rem'}}>
                  {' '}
                  is burned running {maraphons} marathons
                </span>
              </Col>
            </Row>
            <Row className={'pt-4 pb-4'}>
              <Col md={1} />
              <Col md={'auto'}>
                <svg viewBox="67.8 19 64.2 161.9" height="30px" width={'30px'}>
                  <g>
                    <path
                      d="M93.6 121.1c0 1.5 1.1 2.6 2.5 2.6h12.4c1.5 0 2.5-1.1 2.5-2.6s-1.1-2.6-2.5-2.6H96.2c-1.3 0-2.6 1.1-2.6 2.6z"
                      fill="#FFFFFF"
                      data-color="1"
                    ></path>
                    <path
                      d="M132 43.5c0-4.2-2.5-7.9-6.4-9.4-2.2-7.5-8.7-15.1-16-15.1-1.1 0-2.2.2-3.1.6-.7.2-1.5.6-2.2.7-1.5.6-3.1 1.1-4.4 1.1s-2.9-.6-4.4-1.3c-.7-.4-1.5-.6-2.2-.7-.9-.2-2-.4-3.1-.4-7.3 0-13.8 7.5-16 15.1-3.8 1.5-6.4 5.1-6.4 9.4 0 4 2.4 7.5 5.8 9.2-.4.9-.4 2-.4 2.9 0 5.5 4.5 10.1 10 10.1.9 0 1.6-.2 2.4-.4 1.1 2.6 3.6 4.2 6.2 4.6l.7 10.8c-11.6 0-18.9 7.4-18.9 19.1 0 19.1 12.7 67.9 13.3 69.9 2.2 8.8 9.5 11.2 12.9 11.2s10.7-2.4 12.9-11.2c.5-2 13.3-50.8 13.3-69.9 0-11.8-7.3-19.1-18.9-19.1l.7-10.8c2.4-.2 4.9-2 6.2-4.6.7.2 1.6.4 2.4.4 5.5 0 10-4.6 10-10.1 0-.9-.2-2-.4-2.9 3.6-1.7 6-5.2 6-9.2zm-12.2 49.4h-10.9c-1.5 0-2.5 1.1-2.5 2.6s1.3 2.6 2.7 2.6h12v1.8c0 7.4-2 19.7-4.5 31.8h-10.4c-1.5 0-2.5 1.1-2.5 2.6s1.1 2.6 2.5 2.6h9.3c-1.6 7.9-3.5 15.4-4.9 21.1H100c-1.5 0-2.5 1.1-2.5 2.6s1.1 2.6 2.5 2.6h9.3c-.4 1.3-.5 2.4-.9 3.3h-4.2c-1.5 0-2.5 1.1-2.5 2.6s1.1 2.6 2.5 2.6h2.4c-2.4 3.9-6.2 4-6.7 4-.7 0-6.2-.4-8-7.4 0-.2-2-7.5-4.4-17.7h5.6c1.5 0 2.5-1.1 2.5-2.6s-1.1-2.6-2.5-2.6h-6.9c-2.2-9.6-4.5-20.6-6-30.2h6.7c1.5 0 2.5-1.1 2.5-2.6s-1.1-2.6-2.5-2.6h-7.5c-.2-1.5-.4-2.9-.5-4.4h11.6c1.5 0 2.5-1.1 2.5-2.6s-1.1-2.6-2.5-2.6h-12v-.7c0-12.5 9.6-14 13.8-14H107c3.5.2 10.1 1 12.8 7.2zm3.5-44.7c-1.6-1.3-4.7-3.1-9.1-2-1.5.4-2.2 1.7-2 3.1.4 1.5 1.6 2.2 3.1 2 3.1-.7 4.9 1.1 5.3 1.3.7.9 1.1 1.8 1.1 2.9 0 2.8-2.2 5-4.9 5-1.1 0-2-.4-2.9-.9s-2-.7-2.7-.2c-.7.6-1.5 1.5-1.3 2.6v.6c0 1.5-1.3 2.2-2 2.2-.5-.7-1.6-.9-2.5-.7-1.1.4-1.8 1.3-1.8 2.4l-.9 14.3H98l-.9-14.3-.5-5.1c0-1.5-1.3-2.6-2.7-2.4-1.5 0-2.5 1.3-2.4 2.8l.2 2.9c-.5-.4-1.3-1.1-1.3-2v-.6c.2-1.1-.4-2-1.3-2.6-.9-.6-2-.4-2.7.2-.9.7-1.8.9-2.9.9-2.7 0-4.9-2.2-4.9-5 0-1.1.4-2.2 1.1-3.1.5-.7.7-1.8.4-2.8-.4-.9-1.3-1.5-2.2-1.5-2.5-.2-4.7-2.2-4.7-5 0-2.4 1.6-4.4 3.8-4.8.4-.2 2.2-.4 3.6.4.4.2.7.2 1.1.2.9 0 1.8-.6 2.4-1.5.5-1.3.2-2.8-1.1-3.5-.9-.6-2-.7-2.9-.9 2.2-5.1 6.5-9.4 10.4-9.4.5 0 1.1 0 1.6.2s1.3.4 1.8.7c1.8.7 4 1.5 6.2 1.5s4.2-.7 6.2-1.5c.7-.2 1.3-.6 1.8-.7.5-.2 1.1-.2 1.6-.2 4.5 0 10 5.9 11.5 12.5.2.9.9 1.8 2 2 2.2.6 3.8 2.6 3.8 4.8-.1 2.7-1.7 4.7-3.7 5.2z"
                      fill="#FFFFFF"
                      data-color="1"
                    ></path>
                  </g>
                </svg>
              </Col>
              <Col>
                <span style={{fontSize: '1.3rem'}}>
                  {' '}
                  you would get eating {carrots} medium-sized carrots
                </span>
              </Col>
            </Row>
            <Row className={'pt-4 pb-4'}>
              <Col md={1} />
              <Col md={'auto'}>
                <svg viewBox="30.5 47.5 139 105" height="30px" width="30px">
                  <g>
                    <path
                      d="M40.786 75.033a.773.773 0 0 1-.774-.774v-3.646a.774.774 0 1 1 1.548 0v3.646a.774.774 0 0 1-.774.774z"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M40.786 75.033a.772.772 0 0 1-.248-.041l-3.428-1.16a.774.774 0 1 1 .496-1.466l3.428 1.16a.774.774 0 0 1-.248 1.507z"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M40.786 75.033a.774.774 0 0 1-.248-1.507l3.428-1.16a.773.773 0 1 1 .496 1.466l-3.428 1.16a.763.763 0 0 1-.248.041z"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M42.906 77.907a.771.771 0 0 1-.623-.315l-2.119-2.874a.773.773 0 1 1 1.245-.918l2.119 2.874a.773.773 0 0 1-.622 1.233z"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M38.667 77.907a.773.773 0 0 1-.622-1.233l2.118-2.874a.774.774 0 0 1 1.245.918l-2.118 2.874a.768.768 0 0 1-.623.315z"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      fill="#FFFFFF"
                      d="M159.128 48.869a1.369 1.369 0 1 1-2.738 0 1.369 1.369 0 0 1 2.738 0z"
                      data-color="1"
                    ></path>
                    <path
                      fill="#11A2B1"
                      d="M33.238 88.288a1.369 1.369 0 1 1-2.738 0 1.369 1.369 0 0 1 2.738 0z"
                      data-color="2"
                    ></path>
                    <path
                      d="M51.273 121.468c-3.899 0-5.879-1.569-6.857-2.902-1.588-2.165-1.819-5.438-.633-8.981a1.079 1.079 0 0 1 2.045.685c-.96 2.87-.841 5.429.327 7.021 1.016 1.385 2.807 2.052 5.346 2.019 2.595-.046 3.589-1.537 4.964-3.599 1.454-2.18 3.264-4.894 7.599-5.559 4.201-.645 6.142 1.109 7.855 2.658 1.702 1.539 3.175 2.87 7.018 2.278 3.846-.591 4.85-2.299 6.012-4.279 1.169-1.991 2.494-4.247 6.695-4.892 4.325-.662 6.537 1.142 8.491 2.733 1.764 1.437 3.291 2.678 6.383 2.202 3.094-.475 4.177-2.116 5.429-4.016 1.387-2.105 2.96-4.491 7.279-5.154 4.207-.645 6.143 1.11 7.854 2.658 1.703 1.539 3.171 2.87 7.019 2.278 3.846-.591 4.85-2.299 6.012-4.279 1.169-1.99 2.494-4.247 6.695-4.892 4.325-.663 6.536 1.141 8.491 2.733 1.765 1.437 3.295 2.675 6.383 2.202.051-.007 3.472-.516 4.954-3.124 1.069-1.88.928-4.458-.417-7.663a1.08 1.08 0 0 1 1.989-.835c1.622 3.864 1.72 7.089.292 9.582-2.023 3.533-6.329 4.149-6.511 4.174-4.018.617-6.162-1.126-8.052-2.664-1.84-1.499-3.43-2.794-6.801-2.274-3.188.489-4.06 1.973-5.163 3.852-1.258 2.143-2.685 4.572-7.544 5.318-4.861.745-6.949-1.143-8.793-2.81-1.616-1.461-2.893-2.615-6.08-2.126-3.373.518-4.501 2.228-5.806 4.209-1.341 2.035-2.861 4.341-6.902 4.961-4.046.619-6.184-1.123-8.073-2.662-1.839-1.498-3.429-2.791-6.801-2.274-3.188.489-4.06 1.973-5.163 3.852-1.258 2.143-2.685 4.572-7.544 5.318-4.86.746-6.949-1.143-8.792-2.81-1.617-1.461-2.9-2.619-6.081-2.126-3.396.521-4.725 2.514-6.132 4.624-1.404 2.105-2.995 4.492-6.719 4.558-.091.005-.18.006-.268.006z"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M55.497 108.293a5.245 5.245 0 0 1-3.379-1.233 5.307 5.307 0 0 1-1.885-3.963c-.427-22.809 20.389-43.256 48.421-47.56 28.036-4.302 54.023 8.955 60.459 30.842a5.308 5.308 0 0 1-.609 4.346 5.25 5.25 0 0 1-3.633 2.372l-98.577 15.136c-.266.04-.532.06-.797.06zm43.508-50.462c-26.887 4.129-46.857 23.57-46.452 45.223a2.987 2.987 0 0 0 1.059 2.231 2.896 2.896 0 0 0 2.328.654l98.577-15.136c.847-.13 1.566-.6 2.026-1.323a2.99 2.99 0 0 0 .34-2.446c-6.108-20.777-30.989-33.332-57.878-29.203z"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M63.016 152.5a6.112 6.112 0 0 1-5.961-4.809l-1.399-6.453a6.043 6.043 0 0 1 .936-4.75 6.043 6.043 0 0 1 4.102-2.573l97.687-14.999a6.034 6.034 0 0 1 4.684 1.225 6.041 6.041 0 0 1 2.318 4.25l.602 6.575a6.11 6.11 0 0 1-5.151 6.586l-.176-1.147.176 1.147-96.89 14.877a6.1 6.1 0 0 1-.928.071zm96.301-31.335c-.194 0-.39.015-.586.045l-97.686 15a3.745 3.745 0 0 0-2.541 1.594 3.745 3.745 0 0 0-.58 2.943l1.399 6.453a3.787 3.787 0 0 0 4.268 2.935l96.89-14.877a3.784 3.784 0 0 0 3.19-4.081l-.602-6.575a3.742 3.742 0 0 0-1.435-2.633 3.74 3.74 0 0 0-2.317-.804z"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M78.555 75.958a2.037 2.037 0 1 1-3.603-1.901c.525-.995 2.847-3.442 3.842-2.917.995.525.285 3.823-.239 4.818z"
                      fill="#11A2B1"
                      data-color="2"
                    ></path>
                    <path
                      d="M133.082 75.958a2.037 2.037 0 1 0 3.603-1.901c-.525-.995-2.847-3.442-3.842-2.917-.995.525-.286 3.823.239 4.818z"
                      fill="#11A2B1"
                      data-color="2"
                    ></path>
                    <path
                      d="M92.539 87.928a2.037 2.037 0 0 1-4.02-.656c.181-1.11 1.605-4.169 2.715-3.988 1.11.181 1.486 3.534 1.305 4.644z"
                      fill="#11A2B1"
                      data-color="2"
                    ></path>
                    <path
                      d="M118.163 87.928a2.037 2.037 0 0 0 4.02-.656c-.181-1.11-1.605-4.169-2.715-3.988-1.11.181-1.487 3.534-1.305 4.644z"
                      fill="#11A2B1"
                      data-color="2"
                    ></path>
                    <path
                      d="M107.557 71.378a2.037 2.037 0 1 1-4.072.108c-.03-1.124.795-4.396 1.919-4.426 1.124-.029 2.123 3.194 2.153 4.318z"
                      fill="#11A2B1"
                      data-color="2"
                    ></path>
                    <path
                      d="M54.057 130.771a2.517 2.517 0 0 1-.379-5.003l108.949-16.729a2.516 2.516 0 1 1 .764 4.974l-108.95 16.728c-.129.02-.257.03-.384.03z"
                      fill="#11A2B1"
                      data-color="2"
                    ></path>
                    <path
                      d="M139.001 135.59a2.003 2.003 0 0 1-1.978-1.699l-2.674-17.414a2.003 2.003 0 0 1 1.677-2.284 2 2 0 0 1 2.284 1.676l2.674 17.414a2.003 2.003 0 0 1-1.983 2.307z"
                      fill="#11A2B1"
                      data-color="2"
                    ></path>
                    <path
                      d="M145.444 125.902a2.003 2.003 0 0 1-1.978-1.7l-1.381-8.999a2.003 2.003 0 1 1 3.961-.608l1.381 8.999a2.003 2.003 0 0 1-1.983 2.308z"
                      fill="#11A2B1"
                      data-color="2"
                    ></path>
                  </g>
                </svg>
              </Col>
              <Col md={'auto'}>
                <span style={{fontSize: '1.3rem'}}>
                  {bigMacs} Big Macs contain{' '}
                </span>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row
          style={{
            display: 'flex',
            justifyContent: 'center',
            color: 'rgb(17, 162, 177)',
          }}
          className={'pt-5'}
        >
          <span style={{fontSize: '8vh'}}>Christmas song for you</span>
        </Row>
        <Row
          style={{
            display: 'flex',
            justifyContent: 'center',
            color: 'rgb(157, 157, 157)',
          }}
        >
          <span style={{fontSize: '3vh'}}>
            it has closest BPM to your hype heart rate
          </span>
        </Row>
        <Row className={'pl-5 pr-5'}>
          <iframe
            src={`https://open.spotify.com/embed/track/${songId}?utm_source=generator&theme=0`}
            width="100%"
            height="80"
            frameBorder="0"
            allowFullScreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          />
        </Row>
        <Row
          style={{
            display: 'flex',
            justifyContent: 'center',
            color: 'rgb(17, 162, 177)',
          }}
          className={'pt-5'}
        >
          <span style={{fontSize: '8vh'}}>Achievements</span>
        </Row>
        <Row
          style={{display: 'flex', justifyContent: 'center'}}
          className={'pt-5'}
          md={'auto'}
        >
          {achievements.map((a) => (
            <Achievement achievement={a} />
          ))}
        </Row>

        <Row className={'p-5'} />
      </Container>
    );
  }
}

const Achievement = ({achievement}) => {
  let msg1;
  let msg2;
  let picture;
  let title;
  switch (achievement.name) {
    case 'lifetime':
      title = 'BROther in arms';
      msg1 = 'Lifetime supporter 💛';
      msg2 = '';
      picture =
        'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/yearly-report-2021/supporter.png';
      break;
    case 'supporter':
      title = 'BROther in arms';
      msg1 = 'Supporting Pulsoid';
      msg2 = `for ${achievement.value1} days`;
      picture =
        'https://static.wixstatic.com/media/5986ce_32731bd671f14974987a33b6164fa463~mv2.png/v1/fill/w_228,h_228,al_c,q_85,usm_0.66_1.00_0.01/logo500px%20(9).webp';
      break;
    case 'referred':
      title = 'Cupid';
      msg1 = `Referred ${achievement.value1} users`;
      picture =
        'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/yearly-report-2021/referred.png';
      break;
    case 'analyst':
      title = 'Finger on the pulse';
      msg1 = 'Visited Highlights';
      msg2 = `for ${achievement.value1} times`;
      picture =
        'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/yearly-report-2021/analytics.png';
      break;
    case 'integrations':
      title = 'Scripting a bit';
      msg1 = 'Used advanced';
      msg2 = 'integrations';
      picture =
        'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/yearly-report-2021/integrations.png';
      break;
    case 'widgets':
      title = `Widgets ${achievement.value3}`;
      msg1 = `Added ${achievement.value2} widgets`;
      msg2 = `and edited ${achievement.value1} times`;
      picture =
        'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/yearly-report-2021/widgets.png';
      break;
    case 'clips':
      title = 'Editor for hire';
      msg1 = `${achievement.value1} clips were created `;
      msg2 = `by automated clips feature`;
      picture =
        'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/yearly-report-2021/clips.png';
      break;
    case 'avg_hear_rate':
      let avgHeartRateToMax = parseInt(achievement.value1);
      if (avgHeartRateToMax < 60) {
        title = 'Easy mode';
      } else if (avgHeartRateToMax < 70) {
        title = 'Light mode';
      } else if (avgHeartRateToMax < 80) {
        title = 'Moderate mode';
      } else if (avgHeartRateToMax < 90) {
        title = 'Hard mode';
      } else {
        title = 'Vigorous mode';
      }
      msg1 = `Average heart rate is ${achievement.value1}%`;
      msg2 = ' of personal max';
      picture =
        'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/yearly-report-2021/avg-heart-rate.png';
      break;
    case 'times_streamed':
      let times = parseInt(achievement.value1);
      if (times < 50) {
        title = 'Young at heart';
      } else if (times >= 50 && times < 150) {
        title = 'Committed';
      } else {
        title = 'Soulmate';
      }

      msg1 = `Streamed ${times} times`;
      msg2 = '';
      picture =
        'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/yearly-report-2021/times.png';
      break;
    default:
      return null;
  }

  return (
    <Col md={'auto'}>
      <Row>
        <Col>
          <img height={'100vh'} src={picture} />
        </Col>
      </Row>
      <Row className={'pt-2'}>
        <Col>
          <span style={{fontSize: '2em'}}>{title}</span>
        </Col>
      </Row>
      <Row className={'pt-2'}>
        <Col>
          <Row>
            <Col style={{color: 'rgb(157, 157, 157)'}}>{msg1}</Col>
          </Row>
          <Row>
            <Col style={{color: 'rgb(157, 157, 157)'}}>{msg2}</Col>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

const Square = ({icon, comment, value}) => {
  return (
    <Col md={11} style={{border: '2px solid white', borderRadius: '40px'}}>
      <div className={'p-2'}>
        <Roww>
          <Col className={'d-flex align-items-center flex-end'}>
            {icon}
            {/*</Row>*/}
          </Col>
          <Col className={'d-flex align-items-center flex-end'}>
            {/*<Row className={"d-flex flex-end"}>*/}
            <span style={{fontSize: '4em'}}>{value}</span>
            {/*</Row>*/}
          </Col>
        </Roww>
        <Row className={'mt-2'}></Row>
        <Row style={{justifyContent: 'flex-end'}} className={'pr-3'}>
          <h4>{comment}</h4>
        </Row>
      </div>
    </Col>
  );
};

const Roww = ({children}) => (
  <Row style={{justifyContent: 'center'}}>{children}</Row>
);

const Coll = ({children}) => <Col sm={4}>{children}</Col>;

class ShareModal extends React.Component {
  render() {
    let link = 'https://pulsoid.net/pr/report/' + this.props.reportId;
    let img = `https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/yearly-report-2021/screenshots3/${this.props.reportId}.png`;

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.close}
        centered
        size={'lg'}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Easily share your report with friends or viewers
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <h5>Copy public link:</h5>
            </Col>
          </Row>
          <Form.Group as={Row} controlId="formPlaintextPassword">
            <Col sm="10">
              <Form.Control readOnly value={link} />
            </Col>

            <Col>
              <ButtonToolbar>
                <div>
                  <Copy text={link} />
                </div>
              </ButtonToolbar>
            </Col>
          </Form.Group>
          <Row>
            <Col>
              <h3>Share public link via social:</h3>
            </Col>
          </Row>
          <Form.Group as={Row} controlId="formPlaintextPassword">
            <Col sm="7">
              <a
                target={'_blank'}
                href={`https://twitter.com/intent/tweet?text=My%20Pulsoid%202021%20recap%20is%20here%20%E2%9D%A4%EF%B8%8F%0AWhat%20was%20my%20hype%20heart%20rate%20in%202021%F0%9F%93%88%20how%20many%20calories%20I%27ve%20burned%F0%9F%94%A5%20what%20Christmas%20song%20fits%20my%20BPM%F0%9F%8E%84what%20achievements%20I%27ve%20unlocked%F0%9F%8F%86%20and%20even%20more%20cool%20info%20can%20be%20found%20in%20my%20%232021OfMyHeart%20report%20by%20%40pulsoid_app&amp%3Burl=&amp%3Bhashtags=2021OfMyHeart&url=https%3A%2F%2Fpulsoid.net%2Fpr%2Freport%2F${this.props.reportId}`}
              >
                {' '}
                <img src={twitter} style={{height: 40}} alt={'twitter'} />
              </a>
              &nbsp;
              <a
                target={'_blank'}
                href={`https://www.facebook.com/sharer/sharer.php?u=${link}`}
              >
                {' '}
                <img src={facebook} style={{height: 40}} alt={'facebook'} />
              </a>
            </Col>
          </Form.Group>
          <Row>
            <Col>
              <h3>Share screenshot as an image:</h3>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <img
                src={img}
                style={{width: '100%'}}
                alt={'screenshot of 2021 report'}
              />
            </Col>
            <Col className={'d-flex align-items-center'}>
              <ActionHref blank href={img}>
                Open screenshot
              </ActionHref>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}
